import { render, staticRenderFns } from "./BotaoTerritorioSucursales.vue?vue&type=template&id=518b753b&lang=pug"
import script from "./BotaoTerritorioSucursales.vue?vue&type=script&lang=js"
export * from "./BotaoTerritorioSucursales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports